<script setup lang="ts">
import iconDefault from "~/assets/images/brand/recarga-tu-futuro-icon.svg";
import iconLight from "~/assets/images/brand/recarga-tu-futuro-icon-light.svg";
import iconPurple from "~/assets/images/brand/recarga-tu-futuro-icon-purple.svg";
import iconWhite from "~/assets/images/brand/recarga-tu-futuro-icon-white.svg";
import logoDefault from "~/assets/images/brand/recarga-tu-futuro.svg";
import logoLight from "~/assets/images/brand/recarga-tu-futuro-light.svg";
import logoPurple from "~/assets/images/brand/recarga-tu-futuro-purple.svg";
import logoWhite from "~/assets/images/brand/recarga-tu-futuro-white.svg";

type BrandLogoMark = "full" | "icon";
type BrandLogoTone = "default" | "light" | "purple" | "white";

interface BrandLogoProps {
  mark?: BrandLogoMark;
  tone?: BrandLogoTone;
  alt?: string;
  decorative?: boolean;
}

const props = withDefaults(defineProps<BrandLogoProps>(), {
  mark: "full",
  tone: "default",
  alt: "Recarga tu Futuro",
  decorative: false
});

const sources: Record<BrandLogoMark, Record<BrandLogoTone, string>> = {
  full: {
    default: logoDefault,
    light: logoLight,
    purple: logoPurple,
    white: logoWhite
  },
  icon: {
    default: iconDefault,
    light: iconLight,
    purple: iconPurple,
    white: iconWhite
  }
};

const source = computed(() => sources[props.mark][props.tone]);
</script>

<template>
  <img
    class="brand-logo"
    :src="source"
    :alt="decorative ? '' : alt"
    :aria-hidden="decorative || undefined"
  />
</template>

<style scoped lang="scss">
.brand-logo {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}
</style>
